const PLATFORM_LABELS = {
    linux: 'Linux',
    mac: 'Mac',
    windows: 'Windows',
};
/**
 * Check if a build was introspected (has connectedAt or disconnectedAt on any platform).
 * Builds that were introspected cannot be released.
 */
export function wasIntrospected(build) {
    const { introspect } = build;
    if (!introspect)
        return false;
    const platforms = ['mac', 'windows', 'linux'];
    for (const platform of platforms) {
        const data = introspect[platform];
        if ((data === null || data === void 0 ? void 0 : data.connectedAt) || (data === null || data === void 0 ? void 0 : data.disconnectedAt)) {
            return true;
        }
    }
    return false;
}
/**
 * Get list of platform names that were introspected (have connectedAt or disconnectedAt).
 * Returns capitalized platform names (e.g., ['Mac', 'Windows']).
 */
export function getIntrospectedPlatformNames(build) {
    const { introspect } = build;
    if (!introspect)
        return [];
    const platforms = ['mac', 'windows', 'linux'];
    const result = [];
    for (const platform of platforms) {
        const data = introspect[platform];
        if ((data === null || data === void 0 ? void 0 : data.connectedAt) || (data === null || data === void 0 ? void 0 : data.disconnectedAt)) {
            result.push(PLATFORM_LABELS[platform]);
        }
    }
    return result;
}
/**
 * Format introspection status as a human-readable string.
 * Combines breakpoint status and shell status into a single label.
 */
export function formatIntrospectionStatus(breakpointStatus, shellStatus) {
    if (breakpointStatus === 'paused') {
        if (shellStatus === 'connected') {
            return 'paused (shell connected)';
        }
        if (shellStatus === 'disconnected') {
            return 'paused (shell disconnected)';
        }
        return 'paused';
    }
    if (breakpointStatus === 'ready') {
        if (shellStatus === 'connected') {
            return 'ready (shell connected)';
        }
        if (shellStatus === 'disconnected') {
            return 'ready (shell disconnected)';
        }
        return 'ready';
    }
    if (breakpointStatus === 'resuming') {
        return 'resuming';
    }
    if (breakpointStatus === 'initializing') {
        return 'initializing';
    }
    if (breakpointStatus === 'finished') {
        return 'finished';
    }
    if (breakpointStatus === 'error' || shellStatus === 'error') {
        return 'error';
    }
    return 'status unknown';
}
